import { LayoutMatrix } from '../layout-matrix';
export const generateLayouts = (layoutData, layoutState) => {
    const isStatic = layoutState === 'static';
    return layoutData.reduce((acc, current) => {
        const breakpoints = Object.keys(current.layout);
        breakpoints.forEach((breakpointKey) => {
            var _a;
            const layout = current.layout[breakpointKey];
            (_a = acc[breakpointKey]) !== null && _a !== void 0 ? _a : (acc[breakpointKey] = []);
            if (layout) {
                acc[breakpointKey].push({
                    ...layout,
                    i: current.rglId,
                    static: isStatic
                });
            }
        });
        return acc;
    }, {});
};
export const calculateLayoutMatrix = (layoutData, layoutState, cols, defaultSize = 'md', autolayout) => {
    const defaultLayout = generateLayouts(layoutData, layoutState);
    const isStatic = layoutState === 'static';
    if (defaultLayout[defaultSize]) {
        const config = {
            layoutData,
            cols,
            defaultSize,
            isStatic,
            autolayout
        };
        const matrix = new LayoutMatrix(config);
        return matrix.getWidgets();
    }
    return {};
};
